import CountryList from "../../../../component/holidays/holiday-list/CountryList";

export default function Holidays() {
  return (
    <div className="page-body">
      <CountryList />
    </div>
  );
}
